import React, { useState } from 'react';

// Utility to convert comma-separated strings to arrays
const parseStringArray = (str) => {
  return str.split(',').map(s => s.trim()).filter(s => s.length > 0);
};

function ScheduleForm({ onSubmit, isSubmitting }) {
  // Required fields
  const [startDate, setStartDate] = useState('');
  const [goLiveDate, setGoLiveDate] = useState('');
  const [modules, setModules] = useState(''); // Comma separated string
  const [moduleDurationDays, setModuleDurationDays] = useState('4'); 

  // Optional fields
  const [crpCycles, setCrpCycles] = useState('1'); 
  // FIX: Updated default countries to match Lambda (US, IN)
  const [countries, setCountries] = useState('US, IN'); 
  const [blackoutDates, setBlackoutDates] = useState(''); // Comma separated string
  
  // NEW: UAT Override State (Default is FALSE)
  const [overrideUAT, setOverrideUAT] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Basic validation check
    if (!startDate || !goLiveDate || !modules || !moduleDurationDays) {
      alert('Please fill in all required fields.');
      return;
    }

    const payload = {
      start_date: startDate,
      go_live_date: goLiveDate,
      modules: parseStringArray(modules),
      module_duration_days: parseInt(moduleDurationDays), // MUST be an integer
      crp_cycles: parseInt(crpCycles),
      countries: parseStringArray(countries),
      blackout_dates: parseStringArray(blackoutDates),
      // NEW: Include the override flag in the payload
      override_uat_constraint: overrideUAT,
    };
    
    onSubmit(payload);
  };

  return (
    <form onSubmit={handleSubmit}>
      <h3>📅 Required Project Details</h3>
      
      <label>Start Date: <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} required /></label>
      <label>Go Live Date (1st of Month): <input type="date" value={goLiveDate} onChange={e => setGoLiveDate(e.target.value)} required /></label>
      
      <label>Module Duration (Working Days): <input type="number" value={moduleDurationDays} onChange={e => setModuleDurationDays(e.target.value)} min="1" required /></label>
      
      <label>Modules (e.g., GL, AP, FA): <input type="text" value={modules} onChange={e => setModules(e.target.value)} placeholder="GL, AP, FA" required /></label>
      
      <hr/>
      
      <h3>⚙️ Optional Configuration</h3>
      <label>CRP Cycles: <input type="number" value={crpCycles} onChange={e => setCrpCycles(e.target.value)} min="1" /></label>
      {/* FIX: Default value is set in state, placeholder updated */}
      <label>Countries (e.g., US, CA): <input type="text" value={countries} onChange={e => setCountries(e.target.value)} placeholder="US, IN" /></label>
      <label>Blackout Dates (YYYY-MM-DD, separated by comma): <input type="text" value={blackoutDates} onChange={e => setBlackoutDates(e.target.value)} /></label>

      {/* NEW: UAT Override Checkbox */}
      <div style={{marginTop: '20px', marginBottom: '20px', padding: '10px', border: '1px solid #ffcc00', borderRadius: '5px'}}>
        <label>
          <input 
            type="checkbox" 
            checked={overrideUAT} 
            onChange={e => setOverrideUAT(e.target.checked)} 
            style={{marginRight: '10px'}}
          />
          **Override UAT Constraint (Create Anyway)**
        </label>
        <p style={{fontSize: '0.8em', color: '#cc0000', margin: '5px 0 0'}}>Warning: This bypasses the minimum 10 working day gap before Go Live.</p>
      </div>

      <button type="submit" disabled={isSubmitting}>
        {isSubmitting ? 'Generating...' : 'Generate & Download Schedule'}
      </button>
    </form>
  );
}

export default ScheduleForm;